export default {
  productRow1: '数字转型所带来的成本、速度和创新收益是显而易见的，但传统工具为数字化制造了障碍。杰为采用现代使能技术从头从新构建了产品，以满足当今制造商的要求。',
  productRow2: '无论您是刚刚起步转型，还是需要替换当前的软件，杰为拥有的强大的云原生应用软件将帮助您可以按照对业务有意义的节奏部署它们。',
  productRow3: '',
  productRow4: '数字工程',
  productRow5: '数字工厂',
  productRow6: '返回'
}
